import React from 'react';
import storage from 'storage';
import EventStore from './EventStore';
import EventActions from './EventActions';
import EventListItem from './EventListItem';
import Spinner from './Spinner';
import auth from 'auth';
import ExternalShoppingValidator from 'ViewModels/Shared/ExternalShoppingValidator';

export default class EventList extends React.Component {
	constructor(props) {
		super(props);
		this.state = EventStore.getState();
		this.onChange = this.onChange.bind(this);
	}

	componentDidMount() {
		EventStore.listen(this.onChange);
		if(!this.state.EventList || this.state.EventList.length == 0)
			EventActions.getEvents();

	}

	componentWillUnmount() {
		EventStore.unlisten(this.onChange);
	}

	onChange(state) {
		this.setState(state);

        if (eventCode && state.EventList) {
			var event = state.EventList.find(function (e) { return e.code == eventCode });
			if (event) {
				EventStore.unlisten(this.onChange);
                setTimeout(() => { this.props.selectEvent(event); }, 1);
			} else {
				this.props.eventNotAvailable();
			}
		}
	}

	setLSAndRedirect(bookParty) {
        if(bookParty) {
            storage.set('selectedReason','BookAParty');
            storage.set('returnUrl', window.location.href);
        }
        window.location.href = `${window.jenkon.consultantRoot}mystory`;
	}

	renderEventLoading(eventCode) {
        const loadingMessage = this.props.resources["PWS.Events.LoadingEvent"].replace("{0}", eventCode);

        return (
            <ExternalShoppingValidator>
                <div className="site-container icon_button_content animate-in" aria-live="assertive">
                    <div className="blurb text-center">
                        <div className="title">{loadingMessage}</div>
                    </div>
					<Spinner />
				</div>
            </ExternalShoppingValidator>
        )
	}

    renderEventList() {
        if (!this.state.EventList) return <Spinner />;

        const evtList = this.state.EventList
            .filter(e => e.isPublic && !e.isExpired);

        return evtList.map(eventNode =>
            <EventListItem
                key={eventNode.code}
                eventNode={eventNode}
                resources={this.props.resources}
                selectEvent={this.props.selectEvent.bind(this)}
                selectExternalEvent={this.props.selectExternalEvent.bind(this)}
            />
        );
    };

	render() {
		let showPWSPartyLinks = window.jenkon.features.PWS_InternalShoppingPlatform;
		let showShopifyPartyLinks = window.jenkon.showPWSExternalShoppingPlatform === 'True';

		if (eventCode) return this.renderEventLoading(eventCode);

		return (
			<div className="site-container icon_button_content animate-in" aria-live="assertive">
				<div className="blurb text-center">
					<div className="title">{this.props.resources["PWS.Events.EventsListTitle"]}</div>
					<div className="description">{this.props.resources["PWS.Events.EventsListPageDescription"]}</div>
				</div>
				<div id="publicPartiesList" className="section-wrapper clearfix">
					<div className="sectionButtons" style={{textAlign: 'center', margin: '12px 0'}}>
						{/*<button className="bookPartyBtn" onClick={() => this.bookAPartyRedirect()}>{this.props.resources['PWS.Events.BookAPartyButton']}</button>*/}
						<button className="bookPartyBtn" onClick={() => this.setLSAndRedirect(false)}>{this.props.resources['PWS.Events.ContactMeButton']}</button>
					</div>
					<div className="columnHeader partyItem clearfix">
						<div className="partyTitle">{this.props.resources['PWS.Events.PartyTitleLabel']}</div>
						<div className="partyHost">{this.props.resources['PWS.Events.PartyHostLabel']}</div>
						<div className="partyDate" style={{textAlign: 'center'}}>{this.props.resources['PWS.Events.PartyDateLabel']}</div>
						<div className="partyTime" style={{textAlign: 'center'}}>{this.props.resources['PWS.Events.PartyTimeLabel']}</div>
						<div className="partyLocation" style={{ textAlign: 'center' }}>{this.props.resources['PWS.Events.PartyLocationLabel']}</div>
						<div className="partyExpireDate" style={{ textAlign: 'center' }}>{this.props.resources['PWS.Events.PartyExpireDateLabel']}</div>

						{showShopifyPartyLinks && (
							<div className="partyLink" style={{ textAlign: 'center' }}>
								<span className="partyLink" >{this.props.resources['PWS.Events.ShopifyPartyLinkLabel']}</span>
							</div>
						)}
						{showPWSPartyLinks && (
							<div className="partyLink" style={{ textAlign: 'center' }}>
								<span className="partyLink" >{this.props.resources['PWS.Events.PartyLinkLabel']}</span>
							</div>
						)}
					</div>

					{this.renderEventList()}
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/Events/EventList.js